var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', {
    attrs: {
      "offset": "0",
      "open": _vm.isOpen,
      "trigger": "manual",
      "autoHide": false
    }
  }, [_c('button', {
    staticClass: "tooltip-target btn btn-sm btn-link",
    attrs: {
      "data-testid": 'doctor-visit-doctor-' + _vm.visitId
    },
    on: {
      "click": _vm.open
    }
  }, [_c('i', {
    staticClass: "fa fa-exchange",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h3', [_vm._v("změna doktora")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_vm._l((_vm.doctors), function(doctor) {
    return [(doctor.id !== _vm.selectedDoctorId) ? _c('button', {
      staticClass: "btn btn-primary m-1",
      attrs: {
        "data-testid": 'doctor-visit-doctor-option-' + _vm.visitId + '-' + doctor.id
      },
      on: {
        "click": function($event) {
          _vm.changeDoctor(doctor.id)
        }
      }
    }, [_vm._v(_vm._s(doctor.fullname))]) : _c('button', {
      staticClass: "btn btn-primary disabled m-1",
      attrs: {
        "disabled": "disabled"
      }
    }, [_vm._v(_vm._s(doctor.fullname))])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-outline-danger mt-3",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("zavřít")])])])])])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c1bfd45","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/HomeDoctor/components/VisitChangeDoctor.vue
// module id = 384
// module chunks = 0